import request from '../../utils/axios';

// 获取验证码
export function getCode(params) {
    return request({
        url: '/verify',
        method: 'get',
        params
    })
}
// 师傅注册
export function driverRegister(data) {
    return request({
        url: '/h5/driver/register',
        method: 'post',
        data
    })
}
// 师傅详情
export function driverDetail(params) {
    return request({
        url: '/h5/driver/detail',
        method: 'get',
        params
    })
}
// 师傅实名
export function driverIdentity(data) {
    return request({
        url: '/h5/driver/identity',
        method: 'post',
        data
    })
}
// 认证车辆
export function vehicleIdentity(data) {
    return request({
        url: '/h5/vehicle/identity',
        method: 'post',
        data
    })
}
// ocr  身份证识别
export function ocrIdcard(data) {
    return request({
        url: '/v2/ocr/idcard',
        method: 'post',
        data
    })
}
// ocr  驾驶证识别
export function ocrDriver(data) {
    return request({
        url: '/v2/ocr/driver',
        method: 'post',
        data
    })
}
// ocr  行驶证识别
export function ocrVehicle(data) {
    return request({
        url: '/v2/ocr/vehicle',
        method: 'post',
        data
    })
}
// ocr  车牌识别
export function ocrLicense(data) {
    return request({
        url: '/v2/ocr/license',
        method: 'post',
        data
    })
}
// ocr  保单识别
export function ocrInsurance(data) {
    return request({
        url: '/v2/ocr/insurance',
        method: 'post',
        data
    })
}
// 车型参数
export function carmodelParams() {
    return request({
        url: '/v2/param/carmodel',
        method: 'get'
    })
}
// 获取加盟救援项目
export function getJoinService() {
    return request({
        url: '/v2/join/service',
        method: 'get'
    })
}
// 获取行政区域
export function getRegion(params) {
    return request({
        url: '/param/region',
        method: 'get',
        params
    })
}
// 获取加盟认证资料
export function getJoinAttachment(params) {
    return request({
        url: '/v2/join/attachment',
        method: 'get',
        params
    })
}
// 提交加盟
export function driverJoin(data) {
    return request({
        url: '/v2/driver/join',
        method: 'post',
        data
    })
}
// 师傅加盟详情
export function driverJoinInfo(params) {
    return request({
        url: '/v2/driver/join',
        method: 'get',
        params
    })
}